<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-09-15 18:35:09
--> 
<template>
  <div>
    <historyMail></historyMail>
  </div>
</template> 
 
<script>
import historyMail from './historyMail'
export default {
  components: {
    historyMail
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>